import Banner from './index.vue';

export * from './types';
export * as dpBannerTypes from './types/dp-banner';

export default Banner;
